export const companyName = "Protoku";

export const slogan = <>Intelligent software of tomorrow.<br />Delivered today.</>;

export const navigation = [
  { name: 'Features', href: '/#features' },
  { name: 'Pricing', href: '/#pricing' },
  { name: 'FAQ', href: '/#faq' },
  { name: 'Docs', href: 'https://docs.getgg.dev' },
  { name: 'Support', href: 'mailto:hello@getgg.dev' },
];